import { db } from "./db.js";
import { ref } from "vue";

// ==================== READ ====================

function getMemberCount(firmId) {
  return db.collection(`firms/${firmId}/members`).where('status', 'in', ['joined', 'invited']).get().then((snapshot) => {
    return snapshot.size;
  }) ;
}

function getInviteCount(firmId) {
  return db.collection(`firms/${firmId}/invites`).where('status', 'in', ['invited', 'sent']).get().then((snapshot) => {
    return snapshot.size;
  }) ;
}

async function getMembers(firmId) {
  const members = ref([]);
  const snapshot = await db.collection(`firms/${firmId}/members`).where('status', '==', 'joined').get();
  members.value = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

  return members;
}



function getNonAdminMembers(firmId) {
  const members = ref([]);
  db.collection(`firms/${firmId}/members`).where("role", "!=", "admin").where('status', '==', 'joined').get().then(
    (snapshot) => {
      members.value = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    }
  );
  return members;
}

async function getMember(firmId, memberId) {
  const member = await db.doc(`firms/${firmId}/members/${memberId}`).get();
  return member.exists ? member.data() : null;
}

// Role caching: role-aware queries (trademarks, docketing) would otherwise
// block on a server round trip for the membership doc before they can even
// attach. The cached role lets callers construct the right query instantly;
// roles change rarely, and a stale over-privileged role is still safe because
// firestore.rules deny the wider query server-side (callers re-check and
// re-attach — see streamTrademarksOfUser).
const memberRoleCacheKey = (firmId, memberId) => `memberRole:${firmId}:${memberId}`;

function getCachedMemberRole(firmId, memberId) {
  try {
    return localStorage.getItem(memberRoleCacheKey(firmId, memberId));
  } catch (e) {
    return null;
  }
}

// getMember that refreshes the role cache on success
async function getMemberCaching(firmId, memberId) {
  const member = await getMember(firmId, memberId);
  try {
    if (member && member.role) {
      localStorage.setItem(memberRoleCacheKey(firmId, memberId), member.role);
    }
  } catch (e) { /* storage full/blocked — cache is best-effort */ }
  return member;
}

async function getInviteByEmail(firmId, email) {
  const member = await db
    .collection(`firms/${firmId}/invites`)
    .where("email", "==", email)
    .get();

  if (member.docs) {
    return member.docs[0].data();
  }
  return null;
}

// ==================== UPDATE ====================

function updateMember(firmId, memberId, data) {
  return db
    .doc(`firms/${firmId}/members/${memberId}`)
    .set(data, { merge: true });
}

// ==================== DELETE ====================

export {
  getMembers,
  getMember,
  getMemberCaching,
  getCachedMemberRole,
  getMemberCount,
  getInviteCount,
  getInviteByEmail,
  getNonAdminMembers,
  updateMember,
};
